/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VestingMode {
    VALUE = 'VALUE',
    PHYSICAL = 'PHYSICAL',
}
